// extracted by mini-css-extract-plugin
module.exports = {"root":"_3vB5U","top":"LAO4K","bottom":"_2y36A","tile":"_335Kx"};